import { Dispatch, SetStateAction, useEffect, useState } from 'react'

import { SelectChangeEvent } from '@mui/material/Select'
import { Setting, VideoSettingsState } from 'features/videos/service'
import moment from 'moment/moment'

import { Settings } from './Settings'

type Props = {
  playlistId: string
  selectedCourseId: number
  selectedPlaylistsIds: string[]
  setVideoSettingsState: Dispatch<SetStateAction<VideoSettingsState>>
  tabValue: boolean | string
  videoSettingsState: VideoSettingsState
}

export const PlaylistSettings = ({
  playlistId,
  selectedCourseId,
  selectedPlaylistsIds,
  setVideoSettingsState,
  tabValue,
  videoSettingsState,
}: Props) => {
  const getDefaultSetting = (): Setting => ({
    accessLevel: 0,
    courseId: selectedCourseId,
    forLesson: 0,
    // Границы окна видимости по умолчанию отсутствуют (null).
    // Для видео publicVisibility: NONE даты обязательны — это провалидирует бэк.
    maxStudentStartCourseDate: null,
    minStudentStartCourseDate: null,
    playlistId: playlistId,
  })

  const [setting, setSetting] = useState<Setting>(
    videoSettingsState[playlistId]?.[0] || getDefaultSetting()
  )

  const changeAccessLevel = (event: SelectChangeEvent<number>) => {
    setSetting(prev => ({ ...prev, accessLevel: +event.target.value }))
  }

  const changeForLesson = (event: SelectChangeEvent<number>) => {
    setSetting(prev => ({ ...prev, forLesson: +event.target.value }))
  }

  const changeStartDate = (event: null | number) => {
    setSetting(prev => ({
      ...prev,
      // Очистка пикера → null (без границы), а не NaN/1970.
      minStudentStartCourseDate: event ? moment(event).unix() * 1000 : null,
    }))
  }

  const changeEndDate = (event: null | number) => {
    setSetting(prev => ({
      ...prev,
      maxStudentStartCourseDate: event ? moment(event).unix() * 1000 : null,
    }))
  }

  useEffect(() => {
    // Обновляем courseId при изменении selectedCourseId
    setSetting(prev => ({ ...prev, courseId: selectedCourseId }))
  }, [selectedCourseId])

  useEffect(() => {
    setVideoSettingsState(prev => ({
      ...prev,
      [playlistId]: [setting],
    }))
  }, [setting, playlistId, selectedPlaylistsIds])

  return (
    <div hidden={tabValue !== playlistId}>
      {tabValue === playlistId && (
        <>
          <h4>Настройки доступа:</h4>
          <Settings
            accessLevel={setting.accessLevel}
            changeAccessLevel={changeAccessLevel}
            changeEndDate={changeEndDate}
            changeForLesson={changeForLesson}
            changeStartDate={changeStartDate}
            endDate={setting.maxStudentStartCourseDate}
            forLesson={setting.forLesson}
            startDate={setting.minStudentStartCourseDate}
          />
        </>
      )}
    </div>
  )
}
